import React, {
  Component
} from 'react';
import {
  connect
} from 'dva';
import {
  Input,
  Icon,
  Spin
} from 'antd';
import TreeList from '../components/Tree';
import SearchMsg from '../components/Search';
import TableList from '../components/Table';
import DeptInformationTabs from '../DeptInformationTabs';
import PersonDetails from '../components/Details';

@connect(({
  contactsList
}) => ({
  ...contactsList,
}))
class SchoolAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.inputChange = this.inputChange.bind(this);
    this.onPressEnter = this.onPressEnter.bind(this);
  }

  onPressEnter() {
    const {
      dispatch,
      searchValue
    } = this.props;
    if (searchValue.trim().length !== 0) {
      dispatch({
        type: 'contactsList/save',
        payload: {
          isSearch: true,
        },
      });
      dispatch({
        type: 'contactsList/searchFun',
        searchValue,
      });
    } else {
      dispatch({
        type: 'contactsList/save',
        payload: {
          searchResult: [],
        },
      });
    }
  }

  // 输入框内容
  inputChange(val) {
    const {
      dispatch
    } = this.props;
    const {
      value
    } = val.target;
    dispatch({
      type: 'contactsList/save',
      payload: {
        searchValue: value,
      },
    });
  }

  closeResult() {
    const {
      dispatch
    } = this.props;
    dispatch({
      type: 'contactsList/save',
      payload: {
        searchValue: '',
        searchResult: null,
      },
    });
  }

  personDetailsCancel() {
    const {
      dispatch
    } = this.props;
    dispatch({
      type: 'contactsList/save',
      payload: {
        showUserDetailsLayer: false,
        userDetailsSpinning: true,
      },
    });
  }

  render() {
    const {
      searchValue,
      isSearch,
      searchResult,
      showUserDetailsLayer,
      userDetails,
      userDetailsSpinning,
      isRoot,
      deptList,
      columns,
    } = this.props;
    return (
      <div className="addressListTreeWrap">
        <div className="addressListTree">
          <div className="searchWrap">
            <Input
              value={searchValue}
              placeholder="搜姓名,手机号"
              onPressEnter={this.onPressEnter}
              onChange={this.inputChange}
              style={{ width: '100%' }}
              prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }} />}
              suffix={
                <div className="deleteWrap">
                  {searchValue !== '' && (
                    <img
                      alt=""
                      src="https://s.xiaoyuanhao.com/nbugs/images/search bar_icon_delete.svg"
                      onClick={this.closeResult.bind(this)}
                    />
                  )}
                </div>
              }
            />
          </div>
          {isSearch ? (
            <Spin tip="正在读取数据..." />
          ) : searchValue === '' && searchResult === null ? (
            <TreeList />
          ) : (
            <SearchMsg />
          )}
        </div>
        <div className="contents">
          {isRoot === 0 && <TableList dataSource={deptList} columns={columns} tabKey="dept" />}
          {isRoot === 1 && <DeptInformationTabs />}
        </div>
        <PersonDetails
          show={showUserDetailsLayer}
          userDetails={userDetails}
          spinning={userDetailsSpinning}
          handleCancel={this.personDetailsCancel.bind(this)}
        />
      </div>
    );
  }
}

export default SchoolAddress;